<template>
    <section class="widget widget-txt custom-no-results" v-html="noresultsmessage">
    </section>
</template>

<script>
	import * as CONST from '../../utils/constants';

	export default {
		data: function () {
			return {
				noresultsmessage: CONST.globalProject.NoResultsMessage,
			}
		}
    }
</script>